import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./kiosk_peripheral_type.js";
//#region src/kiosk_peripheral_type_helper.ts
var kiosk_peripheral_type_helper_exports = /* @__PURE__ */ __exportAll({
	isSupported: () => isSupported,
	name: () => name
});
function isSupported(peripheralType) {
	switch (peripheralType) {
		case 1:
		case 2:
		case 3:
		case 4:
		case 9: return false;
		case 5:
		case 6:
		case 7:
		case 8: return true;
	}
}
function name(peripheralType) {
	switch (peripheralType) {
		case 1: return "Printer";
		case 2: return "Hybrid Printer";
		case 3: return "Display";
		case 4: return "Keyboard";
		case 5: return "Barcode Scanner";
		case 6: return "Scale";
		case 7: return "MagStripe Reader";
		case 8: return "HID Contactless";
		case 9: return "Storm Audio Nav";
	}
}
//#endregion
export { isSupported, kiosk_peripheral_type_helper_exports, name };

//# sourceMappingURL=kiosk_peripheral_type_helper.js.map